export const GROUP_CART_LIST = "GROUP_CART_LIST";
export const GROUP_CART_LIST_SUCCESS = "GROUP_CART_LIST_SUCCESS";
export const GROUP_CART_LIST_FAIL = "GROUP_CART_LIST_FAIL";

export const GROUP_CART_CREATE = "GROUP_CART_CREATE";
export const GROUP_CART_CREATE_SUCCESS = "GROUP_CART_CREATE_SUCCESS";
export const GROUP_CART_CREATE_FAIL = "GROUP_CART_CREATE_FAIL";

export const GROUP_CART_SINGLE = "GROUP_CART_SINGLE";
export const GROUP_CART_SINGLE_SUCCESS = "GROUP_CART_SINGLE_SUCCESS";
export const GROUP_CART_SINGLE_FAIL = "GROUP_CART_SINGLE_FAIL";

export const UNASSIGNED_ITEMS = "UNASSIGNED_ITEMS";
export const UNASSIGNED_ITEMS_SUCCESS = "UNASSIGNED_ITEMS_SUCCESS";
export const UNASSIGNED_ITEMS_FAIL = "UNASSIGNED_ITEMS_FAIL";

export const GROUP_CART_ADD_ITEMS = "GROUP_CART_ADD_ITEMS";
export const GROUP_CART_ADD_ITEMS_SUCCESS = "GROUP_CART_ADD_ITEMS_SUCCESS";
export const GROUP_CART_ADD_ITEMS_FAIL = "GROUP_CART_ADD_ITEMS_FAIL";

export const INVITE_MEMBER = "INVITE_MEMBER";
export const INVITE_MEMBER_SUCCESS = "INVITE_MEMBER_SUCCESS";
export const INVITE_MEMBER_FAIL = "INVITE_MEMBER_FAILURE";